import React, { useContext } from 'react';
import Button from 'components/Styled/Button/Button';
import RoomProvider from 'components/Provider/RoomProvider';
import SocketProvider from 'components/Provider/SocketProvider';

function StartGame(props) {
    const { room } = useContext(RoomProvider);
    const socket = useContext(SocketProvider);

    const start = ()=>{
        socket.emit('startGame', room.name);
    }

    return (
        <Button
            disabled={!room.canStart}
            onClick={start}
        >
            Démarrer la partie
        </Button>
    );
}

export default StartGame;